export var EAuthenticationMethod;
(function (EAuthenticationMethod) {
    EAuthenticationMethod["PASSWORD"] = "PASSWORD";
    EAuthenticationMethod["BANKID"] = "BANKID";
    EAuthenticationMethod["GOOGLE"] = "GOOGLE";
})(EAuthenticationMethod || (EAuthenticationMethod = {}));
